const model = {
    name: 'ExactAnswer',
    properties: {
        query_types: { type: 'array' },
    },
};
export default model;
